/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from 'graphql-tag';

export const GET_SUPPLY_CHAIN_TEMP = gql`
  query SupplyChainTemplates(
    $where: SupplyChainTemplateWhere
    $options: SupplyChainTemplateOptions
    $stepsOptions2: SupplyChainStepOptions
  ) {
    supplyChainTemplates(where: $where, options: $options) {
      steps(options: $stepsOptions2) {
        icon
        id
        name
        orderedId
        traceOutput
        createdAt
        description
      }
      name
      createdAt
      description
      icon
      id
      org {
        name
        id
      }
    }
  }
`;
